import _castArray from 'lodash/castArray';
import _isNil from 'lodash/isNil';

var castArrayIfPresent = function castArrayIfPresent(value) {
  return !_isNil(value) ? _castArray(value) : value;
};

export default castArrayIfPresent;